export const clientOverallScoresTransformer = response => {
  const list = response?.data?.overallScores ?? []

  const overallThemeTotals = list.map(({ theme, totalScore }) => ({
    label: theme,
    score: totalScore?.value,
    total: totalScore?.total,
  }))

  const scoresBreakdown = {}
  list.forEach(({ theme, meanScores, totalScore }) => {
    scoresBreakdown[theme] = {
      totalScore,
      scores: Object.entries(meanScores).map(([label, { value, total }]) => ({
        label,
        score: value,
        total,
        percent: total ? Math.round((value / total) * 100) : 0,
      })),
    }
  })

  return { overallThemeTotals, scoresBreakdown }
}